var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    clipPath: "url(#clip0_219_1447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.7053 5.05444H12.2949V46.9999H41.7053V5.05444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.7053 45.5344H12.2949V47H41.7053V45.5344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2948 5.05444C12.2948 5.05444 5.65808 7.78088 0 17.1151L7.05719 24.5635L12.2948 19.9439V5.05444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.7051 5.05444C41.7051 5.05444 48.3454 7.78454 53.9999 17.1151L46.9427 24.5635L41.7051 19.9439V5.05444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.1602 1.4619C20.1602 1.4619 21.5774 0 26.9999 0C32.4223 0 33.7018 1.39246 33.7018 1.39246C33.7018 1.39246 30.726 3.49759 26.9999 3.49759C23.2737 3.49759 20.1602 1.4619 20.1602 1.4619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.2949 5.05451C12.2949 5.05451 16.4089 1.93701 27.0001 1.93701C37.5913 1.93701 41.7053 5.05451 41.7053 5.05451H12.2949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27 1.93701C25.4124 1.93701 23.9734 2.00645 22.6685 2.12706C22.6649 2.79222 22.8063 4.31259 23.919 6.48351C25.445 9.46213 27 10.6938 27 10.6938C30.1534 8.00388 31.4655 3.25272 31.7301 2.16726C30.3238 2.02473 28.7507 1.93701 27 1.93701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.535 1.93712C22.6868 1.07094 21.3819 0.85166 20.3018 1.38891L20.1641 1.45835C20.1641 1.45835 21.6103 7.18168 27.0038 10.6939C27.0038 10.6939 23.3828 6.13276 23.5386 1.93712H23.535Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.4688 1.93712C31.317 1.07094 32.6218 0.85166 33.702 1.38891L33.8397 1.45835C33.8397 1.45835 32.3935 7.18168 27 10.6939C27 10.6939 30.621 6.13276 30.4652 1.93712H30.4688Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.943 24.5636L54.0002 17.1153C53.6703 16.5707 53.3368 16.0517 52.9998 15.551L45.6055 23.3868L46.9393 24.5636H46.943Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M0 17.1153L7.05719 24.5636L8.36931 23.4087L0.996778 15.551C0.66331 16.0517 0.329843 16.5707 0 17.1116V17.1153Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M37.4461 13.7308C36.4275 13.7308 35.6011 12.9669 35.6011 12.024C35.6011 11.9692 35.612 11.918 35.6192 11.8668C35.032 11.8339 34.434 11.8157 33.825 11.8157C33.2161 11.8157 32.6217 11.8339 32.0308 11.8668C32.0345 11.9217 32.049 11.9728 32.049 12.024C32.049 12.9669 31.2225 13.7308 30.204 13.7308C30.0808 13.7308 29.9612 13.7198 29.8452 13.6979C29.8162 13.9939 29.7944 14.2899 29.7944 14.5896C29.7944 17.7217 31.3712 20.5067 33.825 22.3194C36.2789 20.5067 37.8557 17.7217 37.8557 14.5896C37.8557 14.2899 37.8339 13.9902 37.8049 13.6979C37.6889 13.7198 37.5693 13.7308 37.4461 13.7308Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M36.413 14.6811C35.6845 14.6811 35.0973 14.1365 35.0973 13.4604C35.0973 13.4202 35.1045 13.3836 35.1082 13.3471C34.6877 13.3252 34.26 13.3105 33.8287 13.3105C33.3973 13.3105 32.9696 13.3252 32.5492 13.3471C32.5528 13.3836 32.56 13.4202 32.56 13.4604C32.56 14.1329 31.9692 14.6811 31.2443 14.6811C31.1573 14.6811 31.0703 14.6738 30.9869 14.6555C30.9652 14.8675 30.9507 15.0794 30.9507 15.2914C30.9507 17.5281 32.0779 19.52 33.8287 20.8174C35.583 19.5236 36.7066 17.5318 36.7066 15.2914C36.7066 15.0758 36.6921 14.8638 36.6704 14.6555C36.587 14.6701 36.5 14.6811 36.413 14.6811Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_1447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.ff21cd5c62dd14fb0f6429ac62f225ef.svg";
export { ForwardRef as ReactComponent };